import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f89962c")

_pushScopeId("data-v-3f89962c")
const _hoisted_1 = { class: "m-0 space-y-4" }
const _hoisted_2 = {
  class: "flex flex-wrap grid grid-cols-7 mr-2 sm:mr-0",
  style: {"margin-top":"12px"}
}
const _hoisted_3 = { class: "flex flex-wrap grid" }
const _hoisted_4 = { class: "w-full -mt-2 sm:-mt-2 mb-0" }
const _hoisted_5 = { class: "text-center text-md leading-6 font-medium text-bp-dark mt-2" }
const _hoisted_6 = { class: "mb-0 md:mb-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DangerAlert = _resolveComponent("DangerAlert")
  const _component_input_field = _resolveComponent("input-field")
  const _component_button_group_select_box = _resolveComponent("button-group-select-box")
  const _component_AggregateChannelSelectBox = _resolveComponent("AggregateChannelSelectBox")
  const _component_DefaultButton = _resolveComponent("DefaultButton")

  return (_openBlock(), _createBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.createChannelForBoostpack && $setup.createChannelForBoostpack(...args)), ["prevent"])),
    ref: "firstStepForm"
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DangerAlert, {
        class: "mt-4",
        "error-message": $setup.errorMessage,
        "error-title": $setup.errorTitle,
        "show-close-button": false,
        "show-title": true
      }, null, 8, ["error-message", "error-title"]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_input_field, {
          class: "col col-span-4",
          value: $setup.subscriptionData.nickname,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ($setup.subscriptionData.nickname = $event)),
          "input-placeholder": _ctx.$t('modal.SubscribeDialog.nickname'),
          "required-field": true,
          "css-class": "my-0 sm:mr-0",
          "input-id": "Nickname"
        }, null, 8, ["value", "input-placeholder"]),
        _createVNode(_component_input_field, {
          class: "col col-span-3",
          value: $setup.subscriptionData.time,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ($setup.subscriptionData.time = $event)),
          "input-placeholder": _ctx.$t('modal.SubscribeDialog.timeTitle'),
          "required-field": true,
          "i-padding": "px-3",
          "css-class": "my-0 ml-2 sm:mt-0 sm:m-2 sm:mb-0 sm:mr-0",
          "input-id": "Time",
          "input-type": "time"
        }, null, 8, ["value", "input-placeholder"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_button_group_select_box, {
            "selected-values": $setup.subscriptionData.duration,
            onOnClickButton: $setup.updateDurationSelection,
            class: "my-2 sm:mt-0 sm:mr-0",
            "required-field": true,
            "input-id": "Duration",
            "input-placeholder": _ctx.$t('modal.SubscribeDialog.durationTitle'),
            buttonValues: [{key: 1, value: _ctx.$t('modal.SubscribeDialog.monday')}, {key: 2, value: _ctx.$t('modal.SubscribeDialog.tuesday')}, {key: 3, value: _ctx.$t('modal.SubscribeDialog.wednesday')}, {key: 4, value: _ctx.$t('modal.SubscribeDialog.thursday')}, {key: 5, value: _ctx.$t('modal.SubscribeDialog.friday')}, {key: 6, value: _ctx.$t('modal.SubscribeDialog.saturday')}, {key: 0, value: _ctx.$t('modal.SubscribeDialog.sunday')}, ]
          }, null, 8, ["selected-values", "onOnClickButton", "input-placeholder", "buttonValues"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_AggregateChannelSelectBox, {
        "input-placeholder": _ctx.$t('modal.SubscribeDialog.selectChannel'),
        "default-email": $setup.subscriptionData.email,
        onInputSubmit: $setup.inputSubmit,
        onUpdateSelectedChannel: $setup.updateSelectedChannel,
        onUpdateEmail: $setup.updateEmail,
        "default-selected-channel": $setup.subscriptionData.selectedChannel
      }, null, 8, ["input-placeholder", "default-email", "onInputSubmit", "onUpdateSelectedChannel", "onUpdateEmail", "default-selected-channel"])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_DefaultButton, {
        "button-text": _ctx.$t('modal.SubscribeDialog.goForward'),
        "button-color": "bg-bp-light",
        "button-hover": "hover:bg-bp-light",
        "button-width": "w-auto",
        "button-x-margin": "mx-auto",
        "center-button": "mb-6",
        "button-type": "submit",
        "custom-css": "disabled:opacity-50 "
      }, null, 8, ["button-text"])
    ])
  ], 544))
})